/* eslint-disable monsterverse-rules/no-uuid-literals */
export const SceneAssets = {
  // Root scenes for each IslandRoom type
  ClassIsland: "0dbc2d29-7e29-4292-8ec7-381c434cd0eb",
  HomeIsland: "70943366-122b-4314-9ac2-c20cb3cb0f00",
  PlaygroundIsland: "0dbc2d29-7e29-4292-8ec7-381c434cd0eb",
  PublicRoleplayIsland: "c06bceee-ac08-4cab-a021-fe022598d47b",

  // Main Haven Layout
  LayoutRings1: "40ae7daa-7d04-4a9d-ba2d-c42a5f80ad9a",
  CampCaldera: "8c6981a1-0adb-43a6-a599-8a2b9f83c913",

  // Activity Hub Default Inserts
  ActivitySelection: "957fc57b-d0c4-43c6-a68f-3f88f81a070c",
  PlaygroundEmptyInsert: "33e9c1e7-901e-4d6b-ab2e-2d92a28d144a",

  // Activity Inserts
  CrowsNest: "73bb82f3-754c-42ac-9991-8dd34a6ad1a6",
  Farm: "19117460-d351-4283-a165-9a16f3e22c35",
  ShadowCourt: "9d6f7506-9edc-4d93-a996-8bdd73667662",
  SpookyLane: "f95be3e0-ebf0-44cd-9e4c-11a022b65ea9",
  Frozone: "74c44f8d-fa06-41a9-8961-86f3eaa4b97a",
  Icescape: "8299deb2-1668-41ff-8a24-5938d8c13bb5",
  CannonBasketball: "5da9745e-0c9c-4b30-b05f-fc64224fea17",
  CannonsInTheRound: "ff3b9e2e-b219-4828-b682-a7e0aba1b465",
  PaintersQuarter: "55ae2994-192f-424f-b01f-be542688a411",
  InkblotCastle: "ad47d9ba-c9ed-4c9e-a53b-62315ab02816",
  MonsterBall: "4ea091b1-2a1a-4378-b607-18129892fccd",
  DolphinPolo: "69c2f4b1-ace8-4570-a7bb-e5d05b35e756",

  Paint: "6614c984-66c5-40dc-9225-917493666fa3",
  PaintForest: "28e758c4-afff-4ef3-b1f0-36c092d1272d",
  PaintOcean: "0d4d30c2-31a1-4c93-8c0a-e98773c45650",
  PaintMojoInTheRound: "7080530d-646d-45ba-a11b-4d7d7960c245",
  PaintCornerCanvas: "80a46642-c601-4bae-9ae3-f217fae32c8a",
  PaintCastle: "5be7ebe9-8d71-4c65-a33b-f68b7ef405e8",
  PaintDragon: "f1120709-09bc-495d-8993-778848d193b2",
  PaintUnicorn: "109b521b-614c-4037-9ca7-7b10e472560b",

  // We use a name for this uuid to indicate that it's a UGC map AND and external asset.
  UgcSelectedArena: "insert_tag_ugc_map",

  PocketWorldEntrance: "208b3f45-ca60-4d16-af58-50ea16f6e99d",
  UgcPocketWorldScene: "43c027d1-74ca-4047-b484-7856190cef65",

  UgcActivityFence: "94312fee-6f60-4273-88c2-594457ca0e88",

  GeoSignActivitiesSymbolGeneric: "86d8bf36-b7b0-48b8-a08c-9aa84267ea05",

  //Playgrounds
  PlaygroundOpen: "43b593e4-495e-4fda-aa5f-c294309e603e",
  PlaygroundClosed: "4f443574-cf45-4ce7-b568-41c0b21ddbaa",
  PlaygroundDisabledOpen: "7456c3db-1e43-4a9a-9f7d-a61ad3203b19",

  // Collectables
  Coconut: "0002a160-2186-45a1-bd5e-a3b01013f737",
  Slime: "00054e02-3e24-4e95-995a-1af5ef3228b6",
  Seashell: "8ffb1e44-8bc7-4cfc-bd0c-52ec3814bc04",
  SeashellBig: "bead5341-3bb0-4bf9-9759-9dc8bce21533",

  // Costumes
  DolphinPink: "747dc528-035b-4327-b612-c7424c206bc4",
  CannonHelmet: "8bb36c24-0d20-4fda-a558-9421da787eb8",

  PropInventoryIsland: "7e25f112-beaa-44dc-a7d4-73b23d3eac86",
  BookshelfNook: "14f002df-916f-40cc-9281-551df5b92a8a",
  BedBook: "2c3111ba-866f-4fca-8a20-2432678a4f96",
  HubDivingSpire: "7620b33b-4102-4837-8419-9b7f38367a75",
  TreePalmLargeShifted: "6d861ce7-27c1-4158-8cc6-b25fa6ea8333",

  QuestFTUEMovement: "ffdf9fba-3ad9-4179-aae9-567883009782",
  QuestFTUEIntroPlayground: "c9732fc1-0a81-48cd-ba84-17ca76117845",
  QuestFTUEGoToPlayground: "b22829e8-d2f4-424a-b90a-6b3d143dcdf0",
  QuestFTUEGoToRPCThenPlayground: "09612479-bade-4227-9db6-bc1d822238a4",
  QuestFTUEExploreRPC: "5cbab867-b9e6-4fda-8467-9f2c8a01e0e7",
  QuestFTUEExploreRPCEnd: "bbf1e9ad-a5db-43d8-9e32-e4aa1f6c110b",
  QuestFTUEGoToRPC: "09612479-bade-4227-9db6-bc1d822238a4",
  QuestFTUERPCToTurtle: "261629f4-ff53-413e-9fd8-5bce2d17e324",

  PenguinVillage: "638c2aa6-053e-4b24-89de-c32769ecc6a5",
  VolcanoIsland: "64b815f9-2a40-4461-9fb9-a95d5b1b955d",
  BigHill: "a821a180-aa5c-4314-8b37-8c5040b5e693",
  SkyIsland: "a6d2a9cc-ff74-41ff-9169-1aef7057fb81",

  pocketWorldSceneA: "3ddd1bbd-11f4-450c-bd18-528c69d3ef90",
  pocketWorldSceneB: "d7515ee4-53e2-418a-9641-3b70b9f03270",

  MathActivityRewardSpawn: "0e14f285-5470-4e8a-86d9-c5f98ee94d33",

  GeoSignActivitiesSymbolDreamschool: "9ef42c60-f162-4eb2-8058-ea82466022e8",
  GeoSignActivitiesSymbolTrickortreat: "5a88ea75-4ae4-4092-9f5d-924f18d4edd3",
  Trickortreat: "c5a2429b-b121-4023-8b42-842c89448e50",
  GeoSignActivitiesSymbolZeroGround: "1514f9b7-5ca9-487c-bb08-466fc942b4ad",
  ZeroGround: "8557f7d0-da6d-435a-adc6-e809b20efc5e",
  GeoSignActivitiesSymbolBoardGame: "9d0a3fe7-01e0-4c9d-bfd6-dc8c992710a3",
  BoardGame: "d8a445f3-56c2-4d47-8c85-0ef29fce39c0",
  GeoSignActivitiesSymbolMathBuilders: "d1970ff5-dc01-4fe6-b86e-e6b35bec0be3",
  MathBuilders: "a15e534a-6298-4d9b-a0fc-1fbd25833453",

  GPSArrowMarker: "e1db51d7-52e2-471f-8285-982faa8d8290",
  TapMoveMarkerGoArrow: "7b00ad6b-dd26-4779-bce3-2cf211cd1ba6",
  TapMoveMarkerGoBase: "63de6856-b413-4da5-8148-b5d2bc8ffa26",
  TapMoveMarkerNoArrow: "4b762ebb-709b-4334-8dc2-e0f48e7c8b39",
  TapMoveMarkerStopBase: "5ef8d71d-cea2-4b6d-82ca-e2a5924660aa",

  BeachBall: "191bc6e6-5eda-49f1-bdf1-70179d9c8e55",

  BTS2024: "71e0d841-040e-47c1-864a-9a056ad8724b",
};
